import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { LOAD_ADD_GUILD_DATA_FROM_LOCAL_STORAGE, SET_ADD_GUILD_PARAMS } from '../actions/guildActionCreator';
import { TAction } from '../actions/types/action';
import frontendLog from '../libs/frontendLog';

const ADDGUILD_LOCAL_STORAGE_KEY = 'rioAddGuild';

function storeParamsInLocalStorage(key: string, params: any) {
  const { localStorage } = window;
  if (localStorage === undefined) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(params));
}

function loadParamsFromLocalStorage(key: string) {
  const { localStorage } = window;
  if (localStorage === undefined) {
    return {};
  }
  const item = localStorage.getItem(key);
  if (item === null || item === undefined || item === '') {
    // silently handle the fact that first time there may be nothing in storage
    return {};
  }

  try {
    return JSON.parse(item);
  } catch (err) {
    frontendLog.error({ err }, `Failed to deserialize ${key} from localStorage`);
  }
  return {};
}

function mergeParamsWithLocalStorage(key: string, params: any) {
  const currentParams = loadParamsFromLocalStorage(key);
  storeParamsInLocalStorage(key, {
    ...currentParams,
    ...params
  });
}

export default function addGuildReducer(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case LOAD_ADD_GUILD_DATA_FROM_LOCAL_STORAGE: {
      return {
        ...state,
        ...loadParamsFromLocalStorage(ADDGUILD_LOCAL_STORAGE_KEY)
      };
    }
    case SET_ADD_GUILD_PARAMS: {
      mergeParamsWithLocalStorage(ADDGUILD_LOCAL_STORAGE_KEY, action.payload);
      return {
        ...state,
        ...action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default:
      return state;
  }
}
